import stepStyles from "../../SelectProperty/SelectPropertyTypePage.module.css";

export const CommercialPicturesStepPage = () => {
  return (
    <>
      <div className={stepStyles.wearDescription}>
        Upload pictures or documents that support your property&apos;s tax protest claims.
      </div>

      <div className={stepStyles.wearExamplesCard}>
        <div className={stepStyles.wearExamplesTitle}>Examples of what to upload:</div>
        <ul className={stepStyles.wearExamplesList}>
          <li>Photos of the property</li>
          <li>Repair/maintenance documents</li>
          <li>Inspection reports</li>
          <li>Supporting paperwork</li>
        </ul>
      </div>
    </>
  );
};
